/* Ordinia: «¿Es para regalar?» (blocks/ordinia-regalo). Abre el panel de regalo, copia la fecha de llegada del bloque
   de entrega y dibuja en un canvas una tarjeta (foto del producto + mensaje) que se descarga o se comparte (WhatsApp, etc.).
   La elección y el texto se recuerdan aunque la ficha se vuelva a pintar al cambiar de variante. */
(function () {
  if (window.__ordGift) return;
  window.__ordGift = true;

  var W = 1080, H = 1350;
  var FONT = '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
  var state = { on: false, to: '', msg: '', from: '' };
  var imgCache = {};

  function box() { return document.querySelector('[data-ord-gift]'); }

  function loadImg(src) {
    if (!src) return Promise.resolve(null);
    if (!imgCache[src]) {
      imgCache[src] = new Promise(function (resolve) {
        var i = new Image();
        i.crossOrigin = 'anonymous';
        i.onload = function () { resolve(i); };
        i.onerror = function () { resolve(null); };
        i.src = src.indexOf('//') === 0 ? location.protocol + src : src;
      });
    }
    return imgCache[src];
  }

  function wrap(ctx, text, maxW) {
    var lines = [];
    String(text).split(/\n/).forEach(function (para) {
      var line = '';
      para.split(/\s+/).forEach(function (w) {
        var test = line ? line + ' ' + w : w;
        if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = w; } else line = test;
      });
      lines.push(line);
    });
    return lines;
  }

  function draw(b) {
    var c = b.querySelector('[data-ord-gift-canvas]');
    if (!c) return Promise.resolve();
    var ctx = c.getContext('2d');
    return loadImg(b.getAttribute('data-img')).then(function (img) {
      ctx.fillStyle = '#f5f5f7';
      ctx.fillRect(0, 0, W, H);

      // Foto del producto (recortada sobre #f5f5f7), centrada en la mitad superior.
      if (img) {
        var side = 660, s = Math.min(side / img.width, side / img.height);
        var iw = img.width * s, ih = img.height * s;
        ctx.drawImage(img, (W - iw) / 2, 90 + (side - ih) / 2, iw, ih);
      }

      var x = 96, maxW = W - 2 * x, y = 830;
      ctx.fillStyle = '#1d1d1f';
      ctx.textBaseline = 'alphabetic';

      var to = state.to.trim();
      ctx.font = '600 64px ' + FONT;
      ctx.fillText(to ? b.getAttribute('data-to').replace('%n', to) : b.getAttribute('data-title'), x, y, maxW);

      y += 74;
      ctx.font = '400 44px ' + FONT;
      ctx.fillStyle = '#424245';
      wrap(ctx, state.msg.trim() || b.getAttribute('data-default-msg'), maxW).slice(0, 5).forEach(function (l) {
        ctx.fillText(l, x, y, maxW); y += 58;
      });

      var from = state.from.trim();
      if (from) {
        ctx.font = '500 40px ' + FONT;
        ctx.fillStyle = '#6e6e73';
        ctx.fillText(b.getAttribute('data-from').replace('%n', from), x, y + 18, maxW);
      }

      // Marca abajo: «Ordinia» + punto terracota.
      ctx.font = '600 40px ' + FONT;
      ctx.fillStyle = '#1d1d1f';
      ctx.fillText('Ordinia', x, H - 80);
      var mw = ctx.measureText('Ordinia').width;
      ctx.fillStyle = '#b4532a';
      ctx.beginPath(); ctx.arc(x + mw + 12, H - 86, 7, 0, Math.PI * 2); ctx.fill();
    });
  }

  function toFile(b) {
    var c = b.querySelector('[data-ord-gift-canvas]');
    return draw(b).then(function () {
      return new Promise(function (resolve) {
        c.toBlob(function (blob) {
          resolve(blob ? new File([blob], (b.getAttribute('data-file') || 'tarjeta') + '.png', { type: 'image/png' }) : null);
        }, 'image/png');
      });
    });
  }

  function apply(b) {
    if (!b || b.getAttribute('data-ord-gift-ready') === String(state.on)) return;
    b.setAttribute('data-ord-gift-ready', String(state.on));
    b.querySelectorAll('[data-ord-gift-opt]').forEach(function (r) { r.checked = (r.value === 'si') === state.on; });
    ['to', 'msg', 'from'].forEach(function (k) {
      var el = b.querySelector('[data-ord-gift-in="' + k + '"]');
      if (el && el.value !== state[k]) el.value = state[k];
    });
    var panel = b.querySelector('[data-ord-gift-panel]');
    if (panel) panel.hidden = !state.on;
    if (!state.on) return;

    var share = b.querySelector('[data-ord-gift-share]');
    if (share && navigator.canShare) {
      try { share.hidden = !navigator.canShare({ files: [new File([''], 'x.png', { type: 'image/png' })] }); } catch (e) {}
    }
    var when = document.querySelector('[data-ord-ent="llega"]');
    var li = b.querySelector('[data-ord-gift-when]');
    if (when && li && when.textContent.trim()) {
      b.querySelector('[data-ord-gift-date]').textContent = when.textContent.trim();
      li.hidden = false;
    }
    draw(b);
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.hasAttribute || !r.hasAttribute('data-ord-gift-opt')) return;
    state.on = r.value === 'si';
    apply(r.closest('[data-ord-gift]'));
  });

  var raf = 0;
  document.addEventListener('input', function (e) {
    var el = e.target;
    var k = el.getAttribute && el.getAttribute('data-ord-gift-in');
    if (!k) return;
    state[k] = el.value;
    var b = el.closest('[data-ord-gift]');
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { draw(b); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ord-gift-share], [data-ord-gift-download]');
    if (!t) return;
    var b = t.closest('[data-ord-gift]');
    var sharing = t.hasAttribute('data-ord-gift-share');
    t.setAttribute('aria-busy', 'true');
    toFile(b).then(function (file) {
      if (!file) return;
      if (sharing) {
        return navigator.share({ files: [file], text: b.getAttribute('data-share-text') }).catch(function () {});
      }
      var a = document.createElement('a');
      a.href = URL.createObjectURL(file);
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }).finally(function () { t.removeAttribute('aria-busy'); });
  });

  // Al cambiar de variante el tema vuelve a pintar el bloque: se restaura la elección y el texto.
  var queued = false;
  new MutationObserver(function () {
    if (!state.on || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(box()); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  // La fecha de llegada se calcula al cargar el bloque de entrega: si el panel ya está abierto, se copia entonces.
  document.addEventListener('DOMContentLoaded', function () { var b = box(); if (b && state.on) { b.removeAttribute('data-ord-gift-ready'); apply(b); } });
})();
